<nav class="navbar">
  <span role="button" class="sidebar-toggler" (click)="toggleSidebar()">
    <i class="feather icon-menu"></i>
  </span>
  <div class="navbar-content">
    <!--- Logo -->
    <a routerLink="/lectures" class="brand m-auto">
      <img src="assets/images/spaceil-logo.png"/>
    </a>
    <ul class="navbar-nav">
      <!-- select leng-->
      <li class="nav-item" ngbDropdown>
        <a class="nav-link" ngbDropdownToggle id="languageDropdown" role="button">
          <span *ngIf=" translate.currentLang === 'en' "><i class="flag-icon flag-icon-us mt-1" title="us"></i> <span class="font-weight-medium ml-1 mr-1 d-none d-md-inline-block">English</span></span>
          <span *ngIf=" translate.currentLang === 'he' "><i class="flag-icon flag-icon-il mt-1" title="he"></i> <span class="font-weight-medium ml-1 mr-1 d-none d-md-inline-block">עברית</span></span>
        </a>
        <div ngbDropdownMenu aria-labelledby="languageDropdown">
          <a ngbDropdownItem class="py-2" (click)="changeLang('en')" ><i class="flag-icon flag-icon-us" title="us" id="us"></i> <span class="ml-1"> English </span></a>
          <a ngbDropdownItem class="py-2" (click)="changeLang('he')"><i class="flag-icon flag-icon-il" title="he" id="il"></i> <span class="ml-1"> עברית </span></a>
        </div>
      </li>

      <!-- select Messages-->
      <!-- <li class="nav-item nav-messages" ngbDropdown>
        <a class="nav-link" ngbDropdownToggle id="messageDropdown">
          <i class="link-icon feather icon-mail"></i>
        </a>
        <div ngbDropdownMenu aria-labelledby="messageDropdown">
          <div class="dropdown-header d-flex align-items-center justify-content-between">
            <p class="mb-0 font-weight-medium">9 New Messages</p>
            <a href="" (click)="false" class="text-muted">Clear all</a>
          </div>
          <div class="dropdown-body">
            <a href="" (click)="false" class="dropdown-item">
              <div class="figure">
                <img src="https://via.placeholder.com/30x30" alt="userr">
              </div>
              <div class="content">
                <div class="d-flex justify-content-between align-items-center">
                  <p>Leonardo Payne</p>
                  <p class="sub-text text-muted">2 min ago</p>
                </div>	
                <p class="sub-text text-muted">Project status</p>
              </div>
            </a>
            <a href="" (click)="false" class="dropdown-item">
              <div class="figure">
                <img src="https://via.placeholder.com/30x30" alt="userr">
              </div>
              <div class="content">
                <div class="d-flex justify-content-between align-items-center">
                  <p>Carl Henson</p>
                  <p class="sub-text text-muted">30 min ago</p>
                </div>	
                <p class="sub-text text-muted">Client meeting</p>
              </div>
            </a>
            <a href="" (click)="false" class="dropdown-item">
              <div class="figure">
                <img src="https://via.placeholder.com/30x30" alt="userr">
              </div>
              <div class="content">
                <div class="d-flex justify-content-between align-items-center">
                  <p>Jensen Combs</p>												
                  <p class="sub-text text-muted">1 hrs ago</p>
                </div>	
                <p class="sub-text text-muted">Project updates</p>
              </div>
            </a>
            <a href="" (click)="false" class="dropdown-item">
              <div class="figure">
                <img src="https://via.placeholder.com/30x30" alt="userr">
              </div>
              <div class="content">
                <div class="d-flex justify-content-between align-items-center">
                  <p>Amiah Burton</p>
                  <p class="sub-text text-muted">2 hrs ago</p>
                </div>
                <p class="sub-text text-muted">Project deadline</p>
              </div>
            </a>
            <a href="" (click)="false" class="dropdown-item">
              <div class="figure">
                <img src="https://via.placeholder.com/30x30" alt="userr">
              </div>
              <div class="content">
                <div class="d-flex justify-content-between align-items-center">
                  <p>Yaretzi Mayo</p>
                  <p class="sub-text text-muted">5 hr ago</p>
                </div>
                <p class="sub-text text-muted">New record</p>
              </div>
            </a>
          </div>
          <div class="dropdown-footer d-flex align-items-center justify-content-center">
            <a href="" (click)="false">View all</a>
          </div>
        </div>
      </li> -->

      <!-- select Notifications-->
      <!-- <li class="nav-item nav-notifications" ngbDropdown>
        <a class="nav-link" ngbDropdownToggle id="notificationDropdown">
          <i class="link-icon feather icon-bell"></i>
          <div class="indicator">
            <div class="circle"></div>
          </div>
        </a>
        <div ngbDropdownMenu aria-labelledby="notificationDropdown">
          <div class="dropdown-header d-flex align-items-center justify-content-between">
            <p class="mb-0 font-weight-medium">6 New Notifications</p>
            <a href="" (click)="false" class="text-muted">Clear all</a>
          </div>
          <div class="dropdown-body">
            <a href="" (click)="false" class="dropdown-item">
              <div class="icon">
                <i class="feather icon-user-plus"></i>
              </div>
              <div class="content">
                <p>New customer registered</p>
                <p class="sub-text text-muted">2 sec ago</p>
              </div>
            </a>
            <a href="" (click)="false" class="dropdown-item">
              <div class="icon">
                <i class="feather icon-gift"></i>
              </div>
              <div class="content">
                <p>New Order Recieved</p>
                <p class="sub-text text-muted">30 min ago</p>
              </div>
            </a>
            <a href="" (click)="false" class="dropdown-item">
              <div class="icon">
                <i class="feather icon-alert-circle"></i>
              </div>
              <div class="content">
                <p>Server Limit Reached!</p>
                <p class="sub-text text-muted">1 hrs ago</p>
              </div>
            </a>
            <a href="" (click)="false" class="dropdown-item">
              <div class="icon">
                <i class="feather icon-layers"></i>
              </div>
              <div class="content">
                <p>Apps are ready for update</p>
                <p class="sub-text text-muted">5 hrs ago</p>
              </div>
            </a>
            <a href="" (click)="false" class="dropdown-item">
              <div class="icon">
                <i class="feather icon-download"></i>
              </div>
              <div class="content">
                <p>Download completed</p>
                <p class="sub-text text-muted">6 hrs ago</p>
              </div>
            </a>
          </div>
          <div class="dropdown-footer d-flex align-items-center justify-content-center">
            <a href="" (click)="false">View all</a>
          </div>
        </div>
      </li> -->

      <!-- select user profile-->
      <li class="nav-item nav-profile" ngbDropdown #myDrop="ngbDropdown" [autoClose]="true">
        <a class="nav-link" ngbDropdownToggle id="profileDropdown"  (click)="getUser()">
          <img appGravatar [user]="userInfo" alt="profile">
        </a>
        <div ngbDropdownMenu aria-labelledby="profileDropdown" (click)="myDrop.close()">
          <div class="dropdown-header d-flex flex-column align-items-center">
            <div class="figure mb-3">
              <img appGravatar [user]="userInfo" alt="">
            </div>
            <div class="info text-center">
              <p class="name font-weight-bold mb-0">{{getDisplayName()}}</p>
              <p class="email text-muted mb-3">{{getEmail()}}</p>
            </div>
          </div>
          <div class="dropdown-body">
            <ul class="profile-nav p-0 pt-3">
              <li class="nav-item">
                <a routerLink="/profile" class="nav-link">
                  <i class="feather icon-user"></i>
                  <span>{{ "PROFILE.DROPDOWN_TITLE" | translate }}</span>
                </a>
              </li>
              <li class="nav-item">
                <span role="button" (click)="logout()" class="nav-link">
                  <i class="feather icon-log-out"></i>
                  <span>{{ "PROFILE.DROPDOWN_LOGOUT" | translate }}</span>
                </span>
              </li>
            </ul>
          </div>
        </div>
      </li>
    </ul>
  </div>
</nav>
